// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes swing {
  0% {
    transform: rotate(0deg);
  }
  10% {
    transform: rotate(10deg);
  }
  30% {
    transform: rotate(0deg);
  }
  40% {
    transform: rotate(-10deg);
  }
  50% {
    transform: rotate(0deg);
  }
  60% {
    transform: rotate(5deg);
  }
  70% {
    transform: rotate(0deg);
  }
  80% {
    transform: rotate(-5deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
@keyframes sonar {
  0% {
    transform: scale(0.9);
    opacity: 1;
  }
  100% {
    transform: scale(2);
    opacity: 0;
  }
}
ion-header {
  position: fixed;
  top: 0;
  box-shadow: none;
}

body {
  font-size: 0.9rem;
}

.navbar-top-header {
  width: auto;
  height: 50px;
  object-fit: contain;
  background-color: white;
}
@media screen and (max-width: 767.9px) {
  .navbar-top-header {
    height: 85px;
  }
}

.navbar_header {
  padding-top: 10px;
  color: #6C0BA9;
  font-weight: 900;
  font-size: 22px;
  text-align: center;
}
@media screen and (max-width: 767.9px) {
  .navbar_header {
    padding-top: 45px;
  }
}

.profile_view::after {
  bottom: 0;
  position: fixed !important;
}

.header-md::after {
  bottom: 0;
  position: fixed !important;
}

.sidebar-wrapper .page-wrapper,
.sidebar-wrapper .sidebar-brand > a,
.sidebar-wrapper .sidebar-dropdown > a:after,
.sidebar-wrapper .sidebar-menu .sidebar-dropdown .sidebar-submenu li a:before,
.sidebar-wrapper ul li a i,
.sidebar-wrapper .sidebar-search input.search-menu,
.sidebar-wrapper .sidebar-search .input-group-text,
.sidebar-wrapper .sidebar-menu ul li a {
  transition: all 0.3s ease;
}

.page-wrapper .page-content,
#show-sidebar,
#close-sidebar {
  transition: all 0.3s ease;
}

/*----------------page-wrapper----------------*/
.page-wrapper .theme {
  width: 40px;
  height: 40px;
  display: inline-block;
  border-radius: 4px;
  margin: 2px;
}
.page-wrapper .theme.chiller-theme {
  background: #1e2229;
}

/*----------------toggeled sidebar----------------*/
.page-wrapper.toggled .sidebar-wrapper {
  left: 0px;
  top: 0px;
}

@media screen and (min-width: 768px) {
  .page-wrapper.toggled .page-content {
    padding-left: 300px;
  }
}
/*----------------show sidebar button----------------*/
#show-sidebar {
  left: 10px;
  top: 10px;
  margin-top: 10px;
  border-radius: 0 4px 4px 0px;
  width: 35px;
  transition-delay: 0.3s;
  background: none;
  border: none;
}

button#show-sidebar.navbar-menu-btn {
  float: left;
  margin-left: 15px;
  padding: 0px;
  background-color: #6c0ba9;
  height: 35px;
  width: 55px;
  font-size: 15px;
  border-radius: 5px;
  border: none;
  margin-top: 10px;
}
@media screen and (max-width: 767.9px) {
  button#show-sidebar.navbar-menu-btn {
    margin-top: 45px;
  }
}

ul#show-sidebar.navbar-profile-btn {
  float: right;
  margin-right: 30px;
  list-style-type: none;
  background: none;
  border: none;
  margin-top: 10px;
}
@media screen and (max-width: 767.9px) {
  ul#show-sidebar.navbar-profile-btn {
    margin-top: 45px;
  }
}

.nav-icon {
  color: #6C0BA9;
}

/*----------------sidebar-wrapper----------------*/
.sidebar-wrapper {
  width: 260px;
  height: 100%;
  max-height: 100%;
  position: fixed;
  top: 0;
  left: -300px;
  z-index: 999;
}
.sidebar-wrapper ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.sidebar-wrapper a {
  text-decoration: none;
}

/*----------------sidebar-content----------------*/
.sidebar-content {
  max-height: calc(100% - 30px);
  height: calc(100% - 30px);
  overflow-y: auto;
  position: relative;
}
.sidebar-content.desktop {
  overflow-y: hidden;
}

.sidebar-wrapper {
  /*-------sidebar-brand--------*/
  /*-------sidebar-header--------*/
  /*-------sidebar-search--------*/
  /*-------sidebar-menu--------*/
  /*------scroll bar--------*/
}
.sidebar-wrapper .sidebar-brand {
  padding: 10px 20px;
  display: flex;
  align-items: center;
  position: fixed;
}
.sidebar-wrapper .sidebar-brand > a {
  text-transform: uppercase;
  font-weight: bold;
  flex-grow: 1;
}
.sidebar-wrapper .sidebar-brand #close-sidebar {
  cursor: pointer;
  font-size: 20px;
}
.sidebar-wrapper .sidebar-header {
  padding: 20px;
  overflow: hidden;
}
.sidebar-wrapper .sidebar-header .user-pic {
  float: left;
  width: 60px;
  padding: 2px;
  border-radius: 12px;
  margin-right: 15px;
  overflow: hidden;
}
.sidebar-wrapper .sidebar-header .user-pic img {
  object-fit: cover;
  height: 100%;
  width: 100%;
}
.sidebar-wrapper .sidebar-header .user-info {
  float: left;
}
.sidebar-wrapper .sidebar-header .user-info > span {
  display: block;
}
.sidebar-wrapper .sidebar-header .user-info .user-role {
  font-size: 12px;
}
.sidebar-wrapper .sidebar-header .user-info .user-status {
  font-size: 11px;
  margin-top: 4px;
}
.sidebar-wrapper .sidebar-header .user-info .user-status i {
  font-size: 8px;
  margin-right: 4px;
  color: #5cb85c;
}
.sidebar-wrapper .sidebar-search > div {
  padding: 10px 20px;
}
.sidebar-wrapper .sidebar-menu {
  cursor: pointer;
  padding-bottom: 70px;
}
.sidebar-wrapper .sidebar-menu .header-menu span {
  font-weight: bold;
  font-size: 14px;
  padding: 15px 20px 5px 20px;
  display: inline-block;
}
.sidebar-wrapper .sidebar-menu ul li a {
  cursor: pointer;
  display: inline-block;
  width: 100%;
  text-decoration: none;
  position: relative;
  padding: 8px 30px 8px 20px;
}
.sidebar-wrapper .sidebar-menu ul li a i {
  margin-right: 10px;
  font-size: 12px;
  width: 30px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  border-radius: 4px;
}
.sidebar-wrapper .sidebar-menu ul li a:hover > i::before {
  display: inline-block;
  animation: swing ease-in-out 0.5s 1 alternate;
}
.sidebar-wrapper .sidebar-menu .sidebar-dropdown > a:after {
  cursor: pointer;
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  content: "\\f105";
  font-style: normal;
  display: inline-block;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  background: 0 0;
  position: absolute;
  right: 15px;
  top: 14px;
}
.sidebar-wrapper .sidebar-menu .sidebar-dropdown .sidebar-submenu ul {
  cursor: pointer;
  padding: 5px 0;
  list-style-type: none !important;
}
.sidebar-wrapper .sidebar-menu .sidebar-dropdown .sidebar-submenu li {
  padding-left: 25px;
  font-size: 13px;
}
.sidebar-wrapper .sidebar-menu .sidebar-dropdown .sidebar-submenu li .fa-square:before {
  font-size: 5px;
}
.sidebar-wrapper ::-webkit-scrollbar {
  width: 5px;
  height: 7px;
}
.sidebar-wrapper ::-webkit-scrollbar-button {
  width: 0px;
  height: 0px;
}
.sidebar-wrapper ::-webkit-scrollbar-thumb {
  background: #525965;
  border: 0px none #ffffff;
  border-radius: 0px;
}
.sidebar-wrapper ::-webkit-scrollbar-thumb:hover, .sidebar-wrapper ::-webkit-scrollbar-thumb:active {
  background: #525965;
}
.sidebar-wrapper ::-webkit-scrollbar-track {
  background: transparent;
  border: 0px none #ffffff;
  border-radius: 50px;
}
.sidebar-wrapper ::-webkit-scrollbar-track:hover, .sidebar-wrapper ::-webkit-scrollbar-track:active {
  background: transparent;
}
.sidebar-wrapper ::-webkit-scrollbar-corner {
  background: transparent;
}

/*----------------------sidebar-menu-------------------------*/
.sidebar-wrapper .sidebar-menu ul li a span.label,
.sidebar-wrapper .sidebar-menu ul li a span.badge {
  float: right;
  margin-top: 8px;
  margin-left: 5px;
}

.sidebar-wrapper .sidebar-menu .sidebar-dropdown .sidebar-submenu li a .badge,
.sidebar-wrapper .sidebar-menu .sidebar-dropdown .sidebar-submenu li a .label {
  float: right;
  margin-top: 0px;
}

.sidebar-wrapper .sidebar-menu .sidebar-submenu {
  display: none;
}

.sidebar-wrapper .sidebar-menu .sidebar-dropdown.active > a:after {
  transform: rotate(90deg);
  right: 17px;
}

.sidebar-wrapper .sidebar-menu ul {
  padding: 5px 0;
  list-style-type: none;
}

/*-------side-footer-------*/
.sidebar-footer {
  position: absolute;
  width: 100%;
  bottom: 0px;
  display: flex;
}
.sidebar-footer > a {
  flex-grow: 1;
  text-align: center;
  height: 30px;
  line-height: 30px;
  position: relative;
}
.sidebar-footer > a .notification {
  position: absolute;
  top: 0;
}

.badge-sonar {
  display: inline-block;
  background: #980303;
  border-radius: 50%;
  height: 8px;
  width: 8px;
  position: absolute;
  top: 0;
}
.badge-sonar :after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  border: 2px solid #980303;
  opacity: 0;
  border-radius: 50%;
  width: 100%;
  height: 100%;
  animation: sonar 1.5s infinite;
}

/*------page-content------*/
.page-wrapper .page-content {
  display: inline-block;
  width: 100%;
  padding-left: 0px;
  padding-top: 20px;
  overflow-x: hidden;
}
.page-wrapper .page-content > div {
  padding: 20px 40px;
}

/*------chiller-theme-------*/
.chiller-theme.page-wrapper.toggled #close-sidebar {
  color: #bdbdbd;
}
.chiller-theme.page-wrapper.toggled #close-sidebar:hover {
  color: #ffffff;
}
.chiller-theme .sidebar-wrapper {
  background: #51087E;
}
.chiller-theme .sidebar-wrapper .sidebar-header,
.chiller-theme .sidebar-wrapper .sidebar-search,
.chiller-theme .sidebar-wrapper .sidebar-menu {
  border-top: 1px solid #3a3f48;
}
.chiller-theme .sidebar-wrapper .sidebar-menu ul li:hover > a,
.chiller-theme .sidebar-wrapper .sidebar-menu .sidebar-dropdown.active > a,
.chiller-theme .sidebar-wrapper .sidebar-header .user-info,
.chiller-theme .sidebar-wrapper .sidebar-brand > a:hover {
  color: #a333e9;
}
.chiller-theme .sidebar-wrapper ul li ul li:hover a:not(.process) i,
.chiller-theme .sidebar-wrapper .sidebar-search input.search-menu:focus + span {
  color: #c26df7;
  text-shadow: 0px 0px 10px rgba(22, 199, 255, 0.5);
}
.chiller-theme .sidebar-wrapper ul li:hover a:not(.process) i,
.chiller-theme .sidebar-wrapper ul li:focus a i .fa-chalkboard {
  color: #c26df7;
  text-shadow: 0px 0px 10px rgba(22, 199, 255, 0.5);
}
.chiller-theme .sidebar-wrapper ul li ul li:not(:hover) a:not(.process) i,
.chiller-theme .sidebar-wrapper .sidebar-search input.search-menu:focus + span {
  color: #fff;
  text-shadow: 0px 0px 10px rgba(22, 199, 255, 0.5);
}
.chiller-theme .sidebar-wrapper .sidebar-menu ul li a i,
.chiller-theme .sidebar-wrapper .sidebar-menu .sidebar-dropdown div {
  background: #3a3f48;
}
.chiller-theme .sidebar-wrapper .sidebar-menu .header-menu span {
  color: #fff;
}
.chiller-theme .sidebar-wrapper .sidebar-search input.search-menu,
.chiller-theme .sidebar-wrapper .sidebar-search .input-group-text {
  background: #3a3f48;
  border-color: transparent;
  box-shadow: none;
}
.chiller-theme .sidebar-wrapper .sidebar-header .user-info .user-role,
.chiller-theme .sidebar-wrapper .sidebar-header .user-info .user-status,
.chiller-theme .sidebar-wrapper .sidebar-search input.search-menu,
.chiller-theme .sidebar-wrapper .sidebar-search .input-group-text,
.chiller-theme .sidebar-wrapper .sidebar-brand > a,
.chiller-theme .sidebar-wrapper .sidebar-menu ul li a {
  color: #fff;
}
.chiller-theme .sidebar-footer {
  background: #3a3f48;
  box-shadow: 0px -1px 5px #282c33;
  border-top: 1px solid #464a52;
}
.chiller-theme .sidebar-footer > a {
  color: #fff;
}
.chiller-theme .sidebar-footer > a:hover i {
  color: #bdbdbd;
}
.chiller-theme .sidebar-footer > a:first-child {
  border-left: none;
}
.chiller-theme .sidebar-footer > a:last-child {
  border-right: none;
}

.ul-none {
  padding: 5px 0 !important;
  list-style-type: none !important;
  margin-left: 0 !important;
}

/*------ sidebar top header ------*/
.sidebar-header-top {
  width: auto;
  height: 50px;
  object-fit: contain;
  background-color: white;
  border-right: 4px inset;
}
@media screen and (max-width: 767.9px) {
  .sidebar-header-top {
    height: 85px;
  }
}

.sidebar-logo {
  float: left;
  height: 100%;
  padding: 5px;
  position: relative;
  top: 0;
}
@media screen and (max-width: 767.9px) {
  .sidebar-logo {
    height: 60%;
    top: 40%;
  }
}

/*------ pinned sidebar ------*/
.pin-sidebar {
  cursor: pointer;
  padding: 0 15px;
  color: #6c0ba9;
  float: right;
  font-size: 0.8em;
  position: relative;
  top: 0;
}
.pin-sidebar.closed-pin {
  padding-top: 16px;
}
.pin-sidebar.open-pin {
  padding-top: 13px;
}
.pin-sidebar:hover {
  cursor: pointer;
  color: #7a2aac;
}
@media screen and (max-width: 767.9px) {
  .pin-sidebar {
    display: none;
    top: 40%;
  }
}

.close-sidebar {
  float: right;
  margin-top: 5px;
}

.pinned-sidebar {
  /*
  .close-sidebar {
    display: none;
  }
  */
}
.pinned-sidebar.sidebar-wrapper {
  cursor: pointer;
  position: fixed;
}
.pinned-sidebar .pin-sidebar:after {
  cursor: pointer;
  content: "/";
  position: relative;
  color: #6c0ba9;
  font-size: 1.6em;
  font-weight: 700;
  transform: rotate(10deg);
}

.HideUser {
  background-color: white;
  color: #6C0BA9;
  padding: 10px;
  border-radius: 3px;
}

.user-name {
  font-size: larger;
  font-weight: bolder;
  min-width: 100px;
  /* Adjust the minimum width as needed */
  max-width: 200px;
  /* Adjust the maximum width as needed */
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.routeColor {
  color: #c26df7;
  font-weight: bold;
}

.routeColor:before {
  color: #a333e9;
}

.routeColor:after {
  color: #a333e9;
}

headerstyle {
  text-align: center;
}

.nav_loader_body {
  position: fixed;
  display: flex;
  height: 100vh;
  width: 100vw;
  justify-content: center;
  align-items: center;
  background: #6C0BA9;
}

.loading {
  display: flex;
}
.loading .dot {
  position: relative;
  width: 2em;
  height: 2em;
  margin: 0.8em;
  border-radius: 0;
}
.loading .dot::before {
  position: absolute;
  content: "";
  width: 100%;
  height: 100%;
  background: inherit;
  border-radius: inherit;
  animation: wave 2s ease-out infinite;
}
.loading .dot:nth-child(1) {
  background: #efbaf6;
}
.loading .dot:nth-child(1)::before {
  animation-delay: 0.2s;
}
.loading .dot:nth-child(2) {
  background: #e189f0;
}
.loading .dot:nth-child(2)::before {
  animation-delay: 0.4s;
}
.loading .dot:nth-child(3) {
  background: #ca6cef;
}
.loading .dot:nth-child(3)::before {
  animation-delay: 0.6s;
}
.loading .dot:nth-child(4) {
  background: #c943e7;
}
.loading .dot:nth-child(4)::before {
  animation-delay: 0.8s;
}
.loading .dot:nth-child(5) {
  background: #cd20f4;
}
.loading .dot:nth-child(5)::before {
  animation-delay: 1s;
}

@keyframes wave {
  50%, 75% {
    transform: scale(2.5);
  }
  80%, 100% {
    opacity: 0;
  }
}
.routeColor:before {
  color: #a333e9;
}

.routeColor:after {
  color: #a333e9;
}`, "",{"version":3,"sources":["webpack://./src/app/components/new-navbar/new-navbar.component.scss"],"names":[],"mappings":"AAEA;EACE;IACE,uBAAA;EADF;EAIA;IACE,wBAAA;EAFF;EAKA;IACE,uBAAA;EAHF;EAMA;IACE,yBAAA;EAJF;EAOA;IACE,uBAAA;EALF;EAQA;IACE,uBAAA;EANF;EASA;IACE,uBAAA;EAPF;EAUA;IACE,wBAAA;EARF;EAWA;IACE,uBAAA;EATF;AACF;AAYA;EACE;IACE,qBAAA;IACA,UAAA;EAVF;EAaA;IACE,mBAAA;IACA,UAAA;EAXF;AACF;AAcA;EACE,eAAA;EACA,MAAA;EACA,gBAAA;AAZF;;AAeA;EACE,iBAAA;AAZF;;AAeA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;AAZF;AAcE;EANF;IAOI,YAAA;EAXF;AACF;;AAcA;EACE,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AAXF;AAaE;EAPF;IAQI,iBAAA;EAVF;AACF;;AAcA;EACE,SAAA;EACA,0BAAA;AAXF;;AAcA;EACE,SAAA;EACA,0BAAA;AAXF;;AAgBE;;;;;;;;EAYE,yBAAA;AAbJ;;AAiBA;;;EAOE,yBAAA;AAdF;;AAiBA,+CAAA;AAKE;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;AAlBJ;AAoBI;EACE,mBAAA;AAlBN;;AAwBA,mDAAA;AAEA;EACE,SAAA;EACA,QAAA;AAtBF;;AAyBA;EACE;IACE,mBAAA;EAtBF;AACF;AAyBA,sDAAA;AACA;EAEE,UAAA;EACA,SAAA;EACA,gBAAA;EACA,4BAAA;EACA,WAAA;EACA,sBAAA;EACA,gBAAA;EACA,YAAA;AAxBF;;AA2BA;EACE,WAAA;EACA,iBAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;AAxBF;AA0BE;EAZF;IAaI,gBAAA;EAvBF;AACF;;AA0BA;EACE,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;AAvBF;AAyBE;EARF;IASI,gBAAA;EAtBF;AACF;;AAyBA;EAEE,cAAA;AAvBF;;AA8BA,kDAAA;AAEA;EACE,YAnNc;EAoNd,YAAA;EACA,gBAAA;EACA,eAAA;EACA,MAAA;EACA,YAAA;EACA,YAAA;AA5BF;AA8BE;EACE,qBAAA;EACA,UAAA;EACA,SAAA;AA5BJ;AA+BE;EACE,qBAAA;AA7BJ;;AAiCA,kDAAA;AAEA;EACE,6BAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;AA/BF;AAiCE;EACE,kBAAA;AA/BJ;;AAqCA;EAEE,+BAAA;EAmBA,gCAAA;EA4CA,gCAAA;EAKA,8BAAA;EAqGA,2BAAA;AAxMF;AAgCE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AA9BJ;AAgCI;EACE,yBAAA;EACA,iBAAA;EACA,YAAA;AA9BN;AAiCI;EACE,eAAA;EACA,eAAA;AA/BN;AAoCE;EACE,aAAA;EACA,gBAAA;AAlCJ;AAoCI;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AAlCN;AAoCM;EACE,iBAAA;EACA,YAAA;EACA,WAAA;AAlCR;AAsCI;EACE,WAAA;AApCN;AAsCM;EACE,cAAA;AApCR;AAuCM;EACE,eAAA;AArCR;AAwCM;EACE,eAAA;EACA,eAAA;AAtCR;AAwCQ;EACE,cAAA;EACA,iBAAA;EACA,cAAA;AAtCV;AA6CE;EACE,kBAAA;AA3CJ;AA+CE;EACE,eAAA;EACA,oBAAA;AA7CJ;AAgDI;EACE,iBAAA;EACA,eAAA;EACA,2BAAA;EACA,qBAAA;AA9CN;AAiDI;EACE,eAAA;EACA,qBAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,0BAAA;AA/CN;AAqDM;EACE,kBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AAnDR;AAsDM;EACE,qBAAA;EACA,6CAAA;AApDR;AAyDM;EACE,eAAA;EACA,kCAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;EACA,mCAAA;EACA,kCAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;AAvDR;AA2DQ;EACE,eAAA;EACA,cAAA;EACA,gCAAA;AAzDV;AA4DQ;EACE,kBAAA;EACA,eAAA;AA1DV;AA4DU;EACE,cAAA;AA1DZ;AAwFE;EACE,UAAA;EACA,WAAA;AAtFJ;AAyFE;EACE,UAAA;EACA,WAAA;AAvFJ;AA0FE;EACE,mBAAA;EAEA,wBAAA;EACA,kBAAA;AAzFJ;AA2FI;EAEE,mBAAA;AA1FN;AA8FE;EACE,uBAAA;EACA,wBAAA;EACA,mBAAA;AA5FJ;AA8FI;EAEE,uBAAA;AA7FN;AAiGE;EACE,uBAAA;AA/FJ;;AAoGA,8DAAA;AAGA;;EAEE,YAAA;EACA,eAAA;EACA,gBAAA;AAnGF;;AAsGA;;EAEE,YAAA;EACA,eAAA;AAnGF;;AAsGA;EACE,aAAA;AAnGF;;AAsGA;EACE,wBAAA;EACA,WAAA;AAnGF;;AAsGA;EACE,cAAA;EACA,qBAAA;AAnGF;;AAkHA,4BAAA;AAEA;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;AAhHF;AAkHE;EACE,YAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AAhHJ;AAkHI;EACE,kBAAA;EACA,MAAA;AAhHN;;AAuHA;EACE,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,MAAA;AApHF;AAsHE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,yBAAA;EACA,UAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;AApHJ;;AAwHA,2BAAA;AAEA;EACE,qBAAA;EACA,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;AAtHF;AAwHE;EACE,kBAAA;AAtHJ;;AA0HA,6BAAA;AAGE;EACE,cAAA;AAzHJ;AA2HI;EACE,cAAA;AAzHN;AA6HE;EAEE,mBAAA;AA5HJ;AA+HE;;;EAGE,6BAAA;AA7HJ;AAgIE;;;;EAIE,cAAA;AA9HJ;AA4IE;;EAEE,cAAA;EACA,iDAAA;AA1IJ;AA8IE;;EAIE,cAAA;EACA,iDAAA;AA9IJ;AAiJE;;EAEE,WAAA;EACA,iDAAA;AA/IJ;AA0JI;;EAEE,mBAAA;AAxJN;AA2JI;EACE,WAAA;AAzJN;AA6JE;;EAEE,mBAAA;EACA,yBAAA;EACA,gBAAA;AA3JJ;AA8JE;;;;;;EAOE,WAAA;AA7JJ;AAgKE;EACE,mBAAA;EACA,gCAAA;EACA,6BAAA;AA9JJ;AAgKI;EAEE,WAAA;AA/JN;AAkKI;EACE,cAAA;AAhKN;AAmKI;EACE,iBAAA;AAjKN;AAoKI;EACE,kBAAA;AAlKN;;AAuKA;EACE,yBAAA;EACA,gCAAA;EACA,yBAAA;AApKF;;AAuKA,mCAAA;AAEA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;AArKF;AAuKE;EAPF;IAQI,YAAA;EApKF;AACF;;AAuKA;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;AApKF;AAsKE;EAPF;IAQI,WAAA;IACA,QAAA;EAnKF;AACF;;AAsKA,+BAAA;AAEA;EACE,eAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,MAAA;AApKF;AAsKE;EACE,iBAAA;AApKJ;AAuKE;EACE,iBAAA;AArKJ;AAwKE;EACE,eAAA;EACA,cAAA;AAtKJ;AAyKE;EAtBF;IAuBI,aAAA;IACA,QAAA;EAtKF;AACF;;AAyKA;EAEE,YAAA;EACA,eAAA;AAvKF;;AA0KA;EAME;;;;GAAA;AAxKF;AAmKE;EACE,eAAA;EACA,eAAA;AAjKJ;AA2KI;EACE,eAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,wBAAA;AAzKN;;AAiLA;EACE,uBAAA;EAEA,cAAA;EAGA,aAAA;EAEA,kBAAA;AAlLF;;AAqLA;EACE,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uCAAA;EACA,gBAAA;EACA,uCAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AAlLF;;AAqLA;EACE,cAAA;EAEA,iBAAA;AAnLF;;AAsLA;EACE,cAAA;AAnLF;;AAsLA;EACE,cAAA;AAnLF;;AAsLA;EACE,kBAAA;AAnLF;;AAwLA;EACE,eAAA;EACA,aAAA;EACA,aAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AArLF;;AAwLA;EAEE,aAAA;AAtLF;AAwLE;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;AAtLJ;AAwLI;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;EACA,oCAAA;AAtLN;AA0LM;EACE,mBAAA;AAxLR;AA0LQ;EACE,qBAAA;AAxLV;AAoLM;EACE,mBAAA;AAlLR;AAoLQ;EACE,qBAAA;AAlLV;AA8KM;EACE,mBAAA;AA5KR;AA8KQ;EACE,qBAAA;AA5KV;AAwKM;EACE,mBAAA;AAtKR;AAwKQ;EACE,qBAAA;AAtKV;AAkKM;EACE,mBAAA;AAhKR;AAkKQ;EACE,mBAAA;AAhKV;;AAuKA;EAEE;IAEE,qBAAA;EAtKF;EAyKA;IAEE,UAAA;EAxKF;AACF;AA4KA;EACE,cAAA;AA1KF;;AA6KA;EACE,cAAA;AA1KF","sourcesContent":["$sidebarWidth : 260px;\r\n\r\n@keyframes swing {\r\n  0% {\r\n    transform: rotate(0deg);\r\n  }\r\n\r\n  10% {\r\n    transform: rotate(10deg);\r\n  }\r\n\r\n  30% {\r\n    transform: rotate(0deg);\r\n  }\r\n\r\n  40% {\r\n    transform: rotate(-10deg);\r\n  }\r\n\r\n  50% {\r\n    transform: rotate(0deg);\r\n  }\r\n\r\n  60% {\r\n    transform: rotate(5deg);\r\n  }\r\n\r\n  70% {\r\n    transform: rotate(0deg);\r\n  }\r\n\r\n  80% {\r\n    transform: rotate(-5deg);\r\n  }\r\n\r\n  100% {\r\n    transform: rotate(0deg);\r\n  }\r\n}\r\n\r\n@keyframes sonar {\r\n  0% {\r\n    transform: scale(0.9);\r\n    opacity: 1;\r\n  }\r\n\r\n  100% {\r\n    transform: scale(2);\r\n    opacity: 0;\r\n  }\r\n}\r\n\r\nion-header {\r\n  position: fixed;\r\n  top: 0;\r\n  box-shadow: none;\r\n}\r\n\r\nbody {\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.navbar-top-header {\r\n  width: auto;\r\n  height: 50px;\r\n  object-fit: contain;\r\n  background-color: white;\r\n\r\n  @media screen and (max-width: 767.9px) {\r\n    height: 85px;\r\n  }\r\n}\r\n\r\n.navbar_header {\r\n  padding-top: 10px;\r\n  color: #6C0BA9;\r\n  font-weight: 900;\r\n  font-size: 22px;\r\n  text-align: center;\r\n\r\n  @media screen and (max-width: 767.9px) {\r\n    padding-top: 45px;\r\n  }\r\n}\r\n\r\n\r\n.profile_view::after {\r\n  bottom: 0;\r\n  position: fixed !important;\r\n}\r\n\r\n.header-md::after {\r\n  bottom: 0;\r\n  position: fixed !important;\r\n}\r\n\r\n.sidebar-wrapper {\r\n\r\n  .page-wrapper,\r\n  .sidebar-brand>a,\r\n  .sidebar-dropdown>a:after,\r\n  .sidebar-menu .sidebar-dropdown .sidebar-submenu li a:before,\r\n  ul li a i,\r\n  .sidebar-search input.search-menu,\r\n  .sidebar-search .input-group-text,\r\n  .sidebar-menu ul li a {\r\n    -webkit-transition: all 0.3s ease;\r\n    -moz-transition: all 0.3s ease;\r\n    -ms-transition: all 0.3s ease;\r\n    -o-transition: all 0.3s ease;\r\n    transition: all 0.3s ease;\r\n  }\r\n}\r\n\r\n.page-wrapper .page-content,\r\n#show-sidebar,\r\n#close-sidebar {\r\n  -webkit-transition: all 0.3s ease;\r\n  -moz-transition: all 0.3s ease;\r\n  -ms-transition: all 0.3s ease;\r\n  -o-transition: all 0.3s ease;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n/*----------------page-wrapper----------------*/\r\n\r\n.page-wrapper {\r\n  // height: 100vh;\r\n\r\n  .theme {\r\n    width: 40px;\r\n    height: 40px;\r\n    display: inline-block;\r\n    border-radius: 4px;\r\n    margin: 2px;\r\n\r\n    &.chiller-theme {\r\n      background: #1e2229;\r\n      // background: transparent !important;\r\n    }\r\n  }\r\n}\r\n\r\n/*----------------toggeled sidebar----------------*/\r\n\r\n.page-wrapper.toggled .sidebar-wrapper {\r\n  left: 0px;\r\n  top: 0px;\r\n}\r\n\r\n@media screen and (min-width: 768px) {\r\n  .page-wrapper.toggled .page-content {\r\n    padding-left: 300px;\r\n  }\r\n}\r\n\r\n/*----------------show sidebar button----------------*/\r\n#show-sidebar {\r\n  // position: fixed;\r\n  left: 10px;\r\n  top: 10px;\r\n  margin-top: 10px;\r\n  border-radius: 0 4px 4px 0px;\r\n  width: 35px;\r\n  transition-delay: 0.3s;\r\n  background: none;\r\n  border: none;\r\n}\r\n\r\nbutton#show-sidebar.navbar-menu-btn {\r\n  float: left;\r\n  margin-left: 15px;\r\n  padding: 0px;\r\n  background-color: #6c0ba9;\r\n  height: 35px;\r\n  width: 55px;\r\n  font-size: 15px;\r\n  border-radius: 5px;\r\n  border: none;\r\n  margin-top: 10px;\r\n\r\n  @media screen and (max-width: 767.9px) {\r\n    margin-top: 45px;\r\n  }\r\n}\r\n\r\nul#show-sidebar.navbar-profile-btn {\r\n  float: right;\r\n  margin-right: 30px;\r\n  list-style-type: none;\r\n  background: none;\r\n  border: none;\r\n  margin-top: 10px;\r\n\r\n  @media screen and (max-width: 767.9px) {\r\n    margin-top: 45px;\r\n  }\r\n}\r\n\r\n.nav-icon {\r\n\r\n  color: #6C0BA9;\r\n}\r\n\r\n// .page-wrapper.toggled #show-sidebar {\r\n//   // left: -40px;\r\n// }\r\n\r\n/*----------------sidebar-wrapper----------------*/\r\n\r\n.sidebar-wrapper {\r\n  width: $sidebarWidth;\r\n  height: 100%;\r\n  max-height: 100%;\r\n  position: fixed;\r\n  top: 0;\r\n  left: -300px;\r\n  z-index: 999;\r\n\r\n  ul {\r\n    list-style-type: none;\r\n    padding: 0;\r\n    margin: 0;\r\n  }\r\n\r\n  a {\r\n    text-decoration: none;\r\n  }\r\n}\r\n\r\n/*----------------sidebar-content----------------*/\r\n\r\n.sidebar-content {\r\n  max-height: calc(100% - 30px);\r\n  height: calc(100% - 30px);\r\n  overflow-y: auto;\r\n  position: relative;\r\n\r\n  &.desktop {\r\n    overflow-y: hidden;\r\n  }\r\n}\r\n\r\n\r\n\r\n.sidebar-wrapper {\r\n\r\n  /*-------sidebar-brand--------*/\r\n  .sidebar-brand {\r\n    padding: 10px 20px;\r\n    display: flex;\r\n    align-items: center;\r\n    position: fixed;\r\n\r\n    >a {\r\n      text-transform: uppercase;\r\n      font-weight: bold;\r\n      flex-grow: 1;\r\n    }\r\n\r\n    #close-sidebar {\r\n      cursor: pointer;\r\n      font-size: 20px;\r\n    }\r\n  }\r\n\r\n  /*-------sidebar-header--------*/\r\n  .sidebar-header {\r\n    padding: 20px;\r\n    overflow: hidden;\r\n\r\n    .user-pic {\r\n      float: left;\r\n      width: 60px;\r\n      padding: 2px;\r\n      border-radius: 12px;\r\n      margin-right: 15px;\r\n      overflow: hidden;\r\n\r\n      img {\r\n        object-fit: cover;\r\n        height: 100%;\r\n        width: 100%;\r\n      }\r\n    }\r\n\r\n    .user-info {\r\n      float: left;\r\n\r\n      >span {\r\n        display: block;\r\n      }\r\n\r\n      .user-role {\r\n        font-size: 12px;\r\n      }\r\n\r\n      .user-status {\r\n        font-size: 11px;\r\n        margin-top: 4px;\r\n\r\n        i {\r\n          font-size: 8px;\r\n          margin-right: 4px;\r\n          color: #5cb85c;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  /*-------sidebar-search--------*/\r\n  .sidebar-search>div {\r\n    padding: 10px 20px;\r\n  }\r\n\r\n  /*-------sidebar-menu--------*/\r\n  .sidebar-menu {\r\n    cursor: pointer;\r\n    padding-bottom: 70px;\r\n    // margin-top: 20%;\r\n\r\n    .header-menu span {\r\n      font-weight: bold;\r\n      font-size: 14px;\r\n      padding: 15px 20px 5px 20px;\r\n      display: inline-block;\r\n    }\r\n\r\n    ul li a {\r\n      cursor: pointer;\r\n      display: inline-block;\r\n      width: 100%;\r\n      text-decoration: none;\r\n      position: relative;\r\n      padding: 8px 30px 8px 20px;\r\n\r\n      // &.process {\r\n      //   padding-left: 60px;\r\n      // }\r\n\r\n      i {\r\n        margin-right: 10px;\r\n        font-size: 12px;\r\n        width: 30px;\r\n        height: 30px;\r\n        line-height: 30px;\r\n        text-align: center;\r\n        border-radius: 4px;\r\n      }\r\n\r\n      &:hover>i::before {\r\n        display: inline-block;\r\n        animation: swing ease-in-out 0.5s 1 alternate;\r\n      }\r\n    }\r\n\r\n    .sidebar-dropdown {\r\n      >a:after {\r\n        cursor: pointer;\r\n        font-family: \"Font Awesome 5 Free\";\r\n        font-weight: 900;\r\n        content: \"\\f105\";\r\n        font-style: normal;\r\n        display: inline-block;\r\n        font-style: normal;\r\n        font-variant: normal;\r\n        text-rendering: auto;\r\n        -webkit-font-smoothing: antialiased;\r\n        -moz-osx-font-smoothing: grayscale;\r\n        text-align: center;\r\n        background: 0 0;\r\n        position: absolute;\r\n        right: 15px;\r\n        top: 14px;\r\n      }\r\n\r\n      .sidebar-submenu {\r\n        ul {\r\n          cursor: pointer;\r\n          padding: 5px 0;\r\n          list-style-type: none !important;\r\n        }\r\n\r\n        li {\r\n          padding-left: 25px;\r\n          font-size: 13px;\r\n\r\n          .fa-square:before {\r\n            font-size: 5px;\r\n            // position: absolute;\r\n            // top: 20px;\r\n          }\r\n\r\n          // .process:before {\r\n          //   content: \"\\f0c8\";\r\n          //   font-family: \"Font Awesome 5 Free\";\r\n          //   font-weight: 400;\r\n          //   font-style: normal;\r\n          //   // display: inline-block;\r\n          //   text-decoration: none;\r\n          //   -webkit-font-smoothing: antialiased;\r\n          //   -moz-osx-font-smoothing: grayscale;\r\n          //   margin-right: 5px;\r\n          //   font-size: 5px;\r\n          //   background-color: white;\r\n          //   margin-top: 100%;\r\n          //   position: absolute;\r\n          //   left: 35px;\r\n          //   bottom: 12px;\r\n          // }\r\n        }\r\n      }\r\n    }\r\n\r\n  }\r\n\r\n  /*------scroll bar--------*/\r\n\r\n  ::-webkit-scrollbar {\r\n    width: 5px;\r\n    height: 7px;\r\n  }\r\n\r\n  ::-webkit-scrollbar-button {\r\n    width: 0px;\r\n    height: 0px;\r\n  }\r\n\r\n  ::-webkit-scrollbar-thumb {\r\n    background: #525965;\r\n    // background: #000;\r\n    border: 0px none #ffffff;\r\n    border-radius: 0px;\r\n\r\n    &:hover,\r\n    &:active {\r\n      background: #525965;\r\n    }\r\n  }\r\n\r\n  ::-webkit-scrollbar-track {\r\n    background: transparent;\r\n    border: 0px none #ffffff;\r\n    border-radius: 50px;\r\n\r\n    &:hover,\r\n    &:active {\r\n      background: transparent;\r\n    }\r\n  }\r\n\r\n  ::-webkit-scrollbar-corner {\r\n    background: transparent;\r\n  }\r\n}\r\n\r\n\r\n/*----------------------sidebar-menu-------------------------*/\r\n\r\n\r\n.sidebar-wrapper .sidebar-menu ul li a span.label,\r\n.sidebar-wrapper .sidebar-menu ul li a span.badge {\r\n  float: right;\r\n  margin-top: 8px;\r\n  margin-left: 5px;\r\n}\r\n\r\n.sidebar-wrapper .sidebar-menu .sidebar-dropdown .sidebar-submenu li a .badge,\r\n.sidebar-wrapper .sidebar-menu .sidebar-dropdown .sidebar-submenu li a .label {\r\n  float: right;\r\n  margin-top: 0px;\r\n}\r\n\r\n.sidebar-wrapper .sidebar-menu .sidebar-submenu {\r\n  display: none;\r\n}\r\n\r\n.sidebar-wrapper .sidebar-menu .sidebar-dropdown.active>a:after {\r\n  transform: rotate(90deg);\r\n  right: 17px;\r\n}\r\n\r\n.sidebar-wrapper .sidebar-menu ul {\r\n  padding: 5px 0;\r\n  list-style-type: none;\r\n}\r\n\r\n// .sidebar-wrapper .sidebar-menu ul {\r\n//   padding: 5px 0;\r\n//   list-style-type: none !important;\r\n// }\r\n\r\n// .sidebar-wrapper .sidebar-menu ul {\r\n//   padding: 5px 0 !important;\r\n//   list-style-type: none !important;\r\n//   margin-left: 0 !important;\r\n// }\r\n\r\n\r\n/*-------side-footer-------*/\r\n\r\n.sidebar-footer {\r\n  position: absolute;\r\n  width: 100%;\r\n  bottom: 0px;\r\n  display: flex;\r\n\r\n  >a {\r\n    flex-grow: 1;\r\n    text-align: center;\r\n    height: 30px;\r\n    line-height: 30px;\r\n    position: relative;\r\n\r\n    .notification {\r\n      position: absolute;\r\n      top: 0;\r\n    }\r\n  }\r\n}\r\n\r\n\r\n\r\n.badge-sonar {\r\n  display: inline-block;\r\n  background: #980303;\r\n  border-radius: 50%;\r\n  height: 8px;\r\n  width: 8px;\r\n  position: absolute;\r\n  top: 0;\r\n\r\n  :after {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    border: 2px solid #980303;\r\n    opacity: 0;\r\n    border-radius: 50%;\r\n    width: 100%;\r\n    height: 100%;\r\n    animation: sonar 1.5s infinite;\r\n  }\r\n}\r\n\r\n/*------page-content------*/\r\n\r\n.page-wrapper .page-content {\r\n  display: inline-block;\r\n  width: 100%;\r\n  padding-left: 0px;\r\n  padding-top: 20px;\r\n  overflow-x: hidden;\r\n\r\n  >div {\r\n    padding: 20px 40px;\r\n  }\r\n}\r\n\r\n/*------chiller-theme-------*/\r\n\r\n.chiller-theme {\r\n  &.page-wrapper.toggled #close-sidebar {\r\n    color: #bdbdbd;\r\n\r\n    &:hover {\r\n      color: #ffffff;\r\n    }\r\n  }\r\n\r\n  .sidebar-wrapper {\r\n    // background: #31353D;\r\n    background: #51087E;\r\n  }\r\n\r\n  .sidebar-wrapper .sidebar-header,\r\n  .sidebar-wrapper .sidebar-search,\r\n  .sidebar-wrapper .sidebar-menu {\r\n    border-top: 1px solid #3a3f48;\r\n  }\r\n\r\n  .sidebar-wrapper .sidebar-menu ul li:hover>a,\r\n  .sidebar-wrapper .sidebar-menu .sidebar-dropdown.active>a,\r\n  .sidebar-wrapper .sidebar-header .user-info,\r\n  .sidebar-wrapper .sidebar-brand>a:hover {\r\n    color: #a333e9;\r\n  }\r\n\r\n\r\n  // .sidebar-wrapper ul li:hover a:not(.process) i,  \r\n  // // .sidebar-wrapper .sidebar-dropdown .sidebar-submenu li a:not(.process):hover:before,\r\n  // .sidebar-wrapper .sidebar-search input.search-menu:focus+span //, .sidebar-wrapper .sidebar-menu .sidebar-dropdown.active a i \r\n\r\n  //   {\r\n  //   // color: #16c7ff;\r\n  //   color: #c26df7;\r\n  //   text-shadow: 0px 0px 10px rgba(22, 199, 255, 0.5);\r\n  // }\r\n\r\n  .sidebar-wrapper ul li ul li:hover a:not(.process) i,\r\n  .sidebar-wrapper .sidebar-search input.search-menu:focus+span {\r\n    color: #c26df7;\r\n    text-shadow: 0px 0px 10px rgba(22, 199, 255, 0.5);\r\n  }\r\n\r\n\r\n  .sidebar-wrapper ul li:hover a:not(.process) i,\r\n  .sidebar-wrapper ul li:focus a i .fa-chalkboard //, .sidebar-wrapper .sidebar-menu .sidebar-dropdown.active a i \r\n\r\n    {\r\n    color: #c26df7;\r\n    text-shadow: 0px 0px 10px rgba(22, 199, 255, 0.5);\r\n  }\r\n\r\n  .sidebar-wrapper ul li ul li:not(:hover) a:not(.process) i,\r\n  .sidebar-wrapper .sidebar-search input.search-menu:focus+span {\r\n    color: #fff;\r\n    text-shadow: 0px 0px 10px rgba(22, 199, 255, 0.5);\r\n  }\r\n\r\n\r\n  // .sidebar-wrapper ul li:hover a.process {\r\n  //   color: white;\r\n  //   text-shadow: 0px 0px 10px rgba(22, 199, 255, 0.5);\r\n  // }\r\n\r\n  .sidebar-wrapper .sidebar-menu {\r\n\r\n    ul li a i,\r\n    .sidebar-dropdown div {\r\n      background: #3a3f48;\r\n    }\r\n\r\n    .header-menu span {\r\n      color: #fff;\r\n    }\r\n  }\r\n\r\n  .sidebar-wrapper .sidebar-search input.search-menu,\r\n  .sidebar-wrapper .sidebar-search .input-group-text {\r\n    background: #3a3f48;\r\n    border-color: transparent;\r\n    box-shadow: none;\r\n  }\r\n\r\n  .sidebar-wrapper .sidebar-header .user-info .user-role,\r\n  .sidebar-wrapper .sidebar-header .user-info .user-status,\r\n  .sidebar-wrapper .sidebar-search input.search-menu,\r\n  .sidebar-wrapper .sidebar-search .input-group-text,\r\n  .sidebar-wrapper .sidebar-brand>a,\r\n  .sidebar-wrapper .sidebar-menu ul li a {\r\n    // color: #818896;\r\n    color: #fff;\r\n  }\r\n\r\n  .sidebar-footer {\r\n    background: #3a3f48;\r\n    box-shadow: 0px -1px 5px #282c33;\r\n    border-top: 1px solid #464a52;\r\n\r\n    >a {\r\n      // color: #818896;\r\n      color: #fff;\r\n    }\r\n\r\n    >a:hover i {\r\n      color: #bdbdbd;\r\n    }\r\n\r\n    >a:first-child {\r\n      border-left: none;\r\n    }\r\n\r\n    >a:last-child {\r\n      border-right: none;\r\n    }\r\n  }\r\n}\r\n\r\n.ul-none {\r\n  padding: 5px 0 !important;\r\n  list-style-type: none !important;\r\n  margin-left: 0 !important;\r\n}\r\n\r\n/*------ sidebar top header ------*/\r\n\r\n.sidebar-header-top {\r\n  width: auto;\r\n  height: 50px;\r\n  object-fit: contain;\r\n  background-color: white;\r\n  border-right: 4px inset;\r\n\r\n  @media screen and (max-width: 767.9px) {\r\n    height: 85px;\r\n  }\r\n}\r\n\r\n.sidebar-logo {\r\n  float: left;\r\n  height: 100%;\r\n  padding: 5px;\r\n  position: relative;\r\n  top: 0;\r\n\r\n  @media screen and (max-width: 767.9px) {\r\n    height: 60%;\r\n    top: 40%;\r\n  }\r\n}\r\n\r\n/*------ pinned sidebar ------*/\r\n\r\n.pin-sidebar {\r\n  cursor: pointer;\r\n  padding: 0 15px;\r\n  color: #6c0ba9;\r\n  float: right;\r\n  font-size: 0.8em;\r\n  position: relative;\r\n  top: 0;\r\n\r\n  &.closed-pin {\r\n    padding-top: 16px;\r\n  }\r\n\r\n  &.open-pin {\r\n    padding-top: 13px;\r\n  }\r\n\r\n  &:hover {\r\n    cursor: pointer;\r\n    color: #7a2aac;\r\n  }\r\n\r\n  @media screen and (max-width: 767.9px) {\r\n    display: none;\r\n    top: 40%;\r\n  }\r\n}\r\n\r\n.close-sidebar {\r\n\r\n  float: right;\r\n  margin-top: 5px;\r\n}\r\n\r\n.pinned-sidebar {\r\n  &.sidebar-wrapper {\r\n    cursor: pointer;\r\n    position: fixed;\r\n  }\r\n\r\n  /*\r\n  .close-sidebar {\r\n    display: none;\r\n  }\r\n  */\r\n\r\n  .pin-sidebar {\r\n    &:after {\r\n      cursor: pointer;\r\n      content: \"/\";\r\n      position: relative;\r\n      color: #6c0ba9;\r\n      font-size: 1.6em;\r\n      font-weight: 700;\r\n      transform: rotate(10deg);\r\n    }\r\n\r\n  }\r\n\r\n}\r\n\r\n\r\n.HideUser {\r\n  background-color: white;\r\n  // background-size: 500px;\r\n  color: #6C0BA9;\r\n  // min-width: 165px;\r\n  // max-width: 300px;\r\n  padding: 10px;\r\n  // font-size: large;\r\n  border-radius: 3px;\r\n}\r\n\r\n.user-name {\r\n  font-size: larger;\r\n  font-weight: bolder;\r\n  min-width: 100px;\r\n  /* Adjust the minimum width as needed */\r\n  max-width: 200px;\r\n  /* Adjust the maximum width as needed */\r\n  overflow: hidden;\r\n  white-space: nowrap;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.routeColor {\r\n  color: #c26df7;\r\n  // font-size: large;\r\n  font-weight: bold;\r\n}\r\n\r\n.routeColor:before {\r\n  color: #a333e9;\r\n}\r\n\r\n.routeColor:after {\r\n  color: #a333e9;\r\n}\r\n\r\nheaderstyle {\r\n  text-align: center;\r\n}\r\n\r\n//  loader css\r\n\r\n.nav_loader_body {\r\n  position: fixed;\r\n  display: flex;\r\n  height: 100vh;\r\n  width: 100vw;\r\n  justify-content: center;\r\n  align-items: center;\r\n  background: #6C0BA9;\r\n}\r\n\r\n.loading {\r\n  $colors: #efbaf6, #e189f0, #ca6cef, #c943e7, #cd20f4;\r\n  display: flex;\r\n\r\n  .dot {\r\n    position: relative;\r\n    width: 2em;\r\n    height: 2em;\r\n    margin: 0.8em;\r\n    border-radius: 0;\r\n\r\n    &::before {\r\n      position: absolute;\r\n      content: \"\";\r\n      width: 100%;\r\n      height: 100%;\r\n      background: inherit;\r\n      border-radius: inherit;\r\n      animation: wave 2s ease-out infinite;\r\n    }\r\n\r\n    @for $i from 1 through 5 {\r\n      &:nth-child(#{$i}) {\r\n        background: nth($colors, $i);\r\n\r\n        &::before {\r\n          animation-delay: $i * 0.2s;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n@keyframes wave {\r\n\r\n  50%,\r\n  75% {\r\n    transform: scale(2.5);\r\n  }\r\n\r\n  80%,\r\n  100% {\r\n    opacity: 0;\r\n  }\r\n}\r\n\r\n\r\n.routeColor:before {\r\n  color: #a333e9;\r\n}\r\n\r\n.routeColor:after {\r\n  color: #a333e9;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
